/**
 * @generated SignedSource<<064fb3b33d5714af46b63caca438d6c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_item" | "useRemoveNegotiationTest_item">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_item";
};
export type PdpRespSidebarSellerInfoAndContactLazy_item$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSidebarSellerInfoAndContact_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRemoveNegotiationTest_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "081e90146a51d1b8605ae0af8e75ef2c";

export default node;
